/* eslint-disable no-unused-vars */
import Common from '../service/common'
import RequestUtils from '../../store/requestUtils'
// import Menu from '../utils/menu'
export default {
  namespaced: true,
  state: {
    // userInfo: JSON.parse(localStorage.getItem('wf.userInfo')) || {},
    // menu: JSON.parse(localStorage.getItem('wf.userMenu')) || {},
    userDetail: JSON.parse(localStorage.getItem('zs.wxUserDetail')) || {}
  },
  mutations: {
    setUserInfo(state, payload) {
      state.userInfo = {
        ...state.userInfo,
        ...payload
      }
    },
    setUserDetail(state, payload) {
      state.userDetail = payload
    },
    setMenu(state, payload) {
      state.menu = payload
    },
    reset(state) {
      // localStorage.clear()
      localStorage.removeItem('wf.userInfo')
      localStorage.removeItem('wf.userMenu')
      state.userInfo = {}
      state.menu = []
      state.userDetail = {}
    }
  },
  actions: {
    // setUserInfo({ commit, state }, payload) {
    //   console.log(state)
    //   commit('updateUserInfo', payload)
    // },
    // login({ commit, state, dispatch }, { payload, success, fail }) {
    //   RequestUtils.fetchWrapper(Common.login(payload), {
    //     type: 'info',
    //     success: res => {
    //       const localData = {
    //         ...res.data,
    //         ...payload
    //       }
    //       localStorage.setItem('wf.userInfo', JSON.stringify(localData))
    //       commit('setUserInfo', localData)
    //       const menu = Menu.ent.slice(0)

    //       menu.forEach(i => {
    //         if (i.index === '2') {
    //           const sub = i.subMenu
    //           if ([100016].indexOf(res.data.vendorId) > -1) {
    //             sub.splice(0, 1)
    //           } else {
    //             sub.splice(1, 1)
    //           }
    //         }
    //       })
    //       localStorage.setItem('wf.userMenu', JSON.stringify(Menu.ent))
    //       commit('setMenu', Menu.ent)
    //       success && success()
    //     },
    //     fail: () => {
    //       fail && fail()
    //     }
    //   })
    // },
    // logout({ commit, state, dispatch }, { payload, success }) {
    //   RequestUtils.fetchWrapper(Common.logout(), {
    //     type: 'info',
    //     success: () => {
    //       success && success()
    //       setTimeout(() => {
    //         commit('reset')
    //       }, 20)
    //     },
    //     fail: () => {}
    //   })
    // },
    // syslogin({ commit, state, dispatch }, { payload, success, fail }) {
    //   RequestUtils.fetchWrapper(Common.syslogin(payload), {
    //     type: 'info',
    //     success: res => {
    //       const localData = {
    //         ...res.data,
    //         ...payload
    //       }
    //       localStorage.setItem('wf.userInfo', JSON.stringify(localData))
    //       commit('setUserInfo', localData)
    //       localStorage.setItem('wf.userMenu', JSON.stringify(Menu.sys))
    //       commit('setMenu', Menu.sys)
    //       success && success()
    //     },
    //     fail: () => {
    //       fail && fail()
    //     }
    //   })
    // },
    // syslogout({ commit, state, dispatch }, { payload, success }) {
    //   RequestUtils.fetchWrapper(Common.syslogout(), {
    //     type: 'info',
    //     success: () => {
    //       success && success()
    //       setTimeout(() => {
    //         commit('reset')
    //       }, 20)
    //     },
    //     fail: () => {}
    //   })
    // },
    uploadfile({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.uploadfile(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getvendor({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getvendor(payload), {
        type: 'info',
        success,
        fail
      })
    },
    modifypassword({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.modifypassword(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updatevendor({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.updatevendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    addvendor({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.addvendor(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateUserDetail({ commit, state, dispatch }, { payload, success, fail }) {
      RequestUtils.fetchWrapper(
        // Promise.all([Common.getvendor(payload), Common.getexpresses(payload)]),
        Common.getvendor(payload),
        {
          type: 'info',
          success: (res) => {
            console.log(res, 'wxaccount/updateUserDetail')
            localStorage.setItem('zs.wxUserDetail', JSON.stringify(res.data))
            commit('setUserDetail', {
              ...res.data
            })
            success && success()
          },
          fail
        }
      )
    },
    getzsvendors(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getzsvendors(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getallexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getallexpresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getexpresses(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.getexpresses(payload), {
        type: 'list',
        success,
        fail
      })
    },
    setvendorexpress(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setvendorexpress(payload), {
        type: 'action',
        success,
        fail
      })
    },
    setvendoradminuser(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setvendoradminuser(payload), {
        type: 'action',
        success,
        fail
      })
    },
    setpoints2cashratio(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Common.setpoints2cashratio(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
